import React from 'react';
import SideNav from '../theme/menus/sideNav';
import { connect } from 'react-redux';
import { useHistory } from 'react-router';
import CampaignSelector from '../theme/menus/CampaignSelector';
import { toggleSideBar } from '../../store/actions';
import { Link } from 'react-router-dom';

class NavBaseTemplate extends React.Component {
  render() {
    return (
      <div className={`flx__navmain ${this.props.sidebarClosed ? 'min-menu' : ''}`}>
        <SideNav location={this.props.location} showAdmin={this.props.showAdmin} />

        <main className="flx__main">
          <div className="flx__main__headerbody">
            <div className="flx__main__subheaderbody">
              <div className="flx__main__header">
                <div className={`left-side`}>
                  {this.props.history && (
                    <i className={`fas fa-arrow-left`} onClick={() => this.props.history.go(-1)} />
                  )}
                  <i
                    className={`fas ${
                      this.props.sidebarClosed ? 'fa-bars' : 'fa-expand-arrows-alt'
                    }`}
                    onClick={this.props.toggleSideBar}
                  />
                  <Link to="/profile">
                    <i className={`fas fa-user`} />
                  </Link>
                  {this.props.sidebarClosed && <span className="closed-logo">ElecTrek</span>}
                </div>
                <div className={`right-side`}>
                  <CampaignSelector disabled={this.props.disabled} />
                </div>
              </div>
              <div className="flx__main__body">
                <div className="flx__main__wrap">
                  <div className="flx__main__body__left">
                    <div id="main_content_container">
                      <div className="main-wrapper">{this.props.children}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  sidebarClosed: state.session.sidebarClosed,
});

const mapDispatchToProps = (dispatch) => ({
  toggleSideBar: () => dispatch(toggleSideBar()),
});

export default connect(mapStateToProps, mapDispatchToProps)(NavBaseTemplate);
